export const Colors = {
	primary: '#EF8200',
	secondary: '#4E0F06',

	white: '#FFF',
	black: '#000',
	purple: '#BB6BD9',
	screen: '#E5E5E5',
} as const;
